module.exports = __webpack_public_path__ + "static/img/编组11@2x.4668a1e4.png";